// Resolve qual variante de imagem (padrão vs branca) usar no brand do
// escritório. Prioriza a variante branca cadastrada quando a feature
// "Navegação cor única" está ativa OU quando o bg-navbar atual é escuro —
// mesmo critério de contraste de _base-logo-loading.vue
// (textOnColor(bgNavbar) === '#FFFFFF'). A navbar antiga só olhava a
// feature porque o header dela (bg-navbar-header) era branco por padrão; a
// sidebar nova (bg-navbar) é escura por padrão independente da feature, então
// a feature sozinha não garante contraste aqui.
export function resolveOfficeBrandImage({ onlyColorFeature, bgIsDark, image, imageBranca }) {
  const preferBranca = onlyColorFeature || bgIsDark
  if (preferBranca && imageBranca && imageBranca.length) {
    return imageBranca
  }
  return image
}
